import type { Article, RelatedArticleRef } from '@/lib/articles';

export type ArticleCarouselItem = {
  slug: string;
  title: string;
  dateLabel?: string;
  imageSrc?: string;
  imageAlt?: string;
};

type ArticleCarouselSource = {
  slug: string;
  title?: string;
  publishDate?: string;
  heroImage?: { src?: string; alt?: string };
  imageSrc?: string;
  imageAlt?: string;
};

const dateFormatter = new Intl.DateTimeFormat('en-US', {
  year: 'numeric',
  month: 'long',
  day: 'numeric',
  timeZone: 'UTC',
});

function articleDate(date: string | undefined) {
  if (!date) return undefined;
  return dateFormatter.format(new Date(date));
}

export function toArticleCarouselItem(item: ArticleCarouselSource): ArticleCarouselItem {
  const dateLabel = articleDate(item.publishDate);
  const imageSrc = item.imageSrc ?? item.heroImage?.src;
  const imageAlt = item.imageAlt ?? item.heroImage?.alt;

  return {
    slug: item.slug,
    title: item.title ?? item.slug,
    ...(dateLabel ? { dateLabel } : {}),
    ...(imageSrc ? { imageSrc } : {}),
    ...(imageAlt ? { imageAlt } : {}),
  };
}

export function articleToCarouselItem(article: Article): ArticleCarouselItem {
  return toArticleCarouselItem(article);
}

export function relatedArticleToCarouselItem(item: RelatedArticleRef): ArticleCarouselItem {
  return toArticleCarouselItem(item);
}
